export const EmergencySituationInstructions = {
  None: 'None',
  Cpr: 'Cpr',
  Choking: 'Choking',
  Unconsciousness: 'Unconsciousness',
  Bleeding: 'Bleeding',
  Nosebleeds: 'Nosebleeds',
  GpsInstructionsIos: 'GpsInstructionsIos',
  GpsInstructionsAndroid: 'GpsInstructionsAndroid',
  CameraInstructionsIos: 'CameraInstructionsIos',
  CameraInstructionsAndroid: 'CameraInstructionsAndroid',
  ChildChoking: 'ChildChoking',
} as const;

export type EmergencySituationInstructions = (typeof EmergencySituationInstructions)[keyof typeof EmergencySituationInstructions];
